/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createNaN } from '../../factoriesAny.js';
export var NaNDependencies = {
  BigNumberDependencies,
  createNaN
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesNaN.generated.js
// module id = null
// module chunks = 